import i18n from '@/i18n'
import errorIndex from './index'
import error503Page from './503'
import error404Page from './404'
import noPermissionPage from './noPermission'
import internalOnlyMicroSiteErrorPage from './internalOnlyMicroSite'
import noAccessToComapnySurvey from './noAccessToComapnySurvey'
import linkExpired from './linkExpired'

const notFoundRouter = {
  name: '404Error',
  path: '/error/404.html',
  component: error404Page,
  meta: {
    title: ''
  }
}

export default {
  name: 'errorIndex',
  path: '*',
  component: errorIndex,
  redirect: notFoundRouter.path,
  meta: {
    noAuth: true
  },
  children: [
    {
      name: '503Error',
      path: '/error/503.html',
      component: error503Page,
      meta: {
        title: 'Er...'
      }
    },
    notFoundRouter,
    {
      name: 'noPermissionError',
      path: '/error/no-permission',
      component: noPermissionPage,
      meta: {
        title: ''
      }
    },
    {
      name: 'internalOnlyMicroSiteError',
      path: '/error/internal-only/microsite',
      component: internalOnlyMicroSiteErrorPage,
      meta: {
        get title () {
          return i18n.t('error.page.internalOnlyMicroSite.title')
        }
      }
    },
    {
      name: 'noAccessToComapnySurvey',
      path: '/error/no-access-to-comapny-survey',
      component: noAccessToComapnySurvey,
      meta: {
        get title () {
          return i18n.t('error.page.noAccessToComapnySurvey.title')
        }
      }
    },
    {
      name: 'linkExpired',
      path: '/error/link-expired',
      component: linkExpired,
      meta: {
        get title () {
          return i18n.t('error.page.linkExpired.title')
        }
      }
    }
  ]
}

export { notFoundRouter }
